import { ChangeEvent } from 'react'

const inputResolver = (setFunction: (state: any) => void) => (
  e: ChangeEvent<HTMLInputElement>,
) => setFunction(e.target.value)

export default inputResolver
